export const buildReceiptMutationConfirmationSummary = preview => ({
    changedCount: (preview?.removed_items || []).length
        + (preview?.changed_items || []).length + (preview?.added_items || []).length,
    productReversal: Number(preview?.product_payment_to_reverse || 0),
    serviceReversal: Number(preview?.service_allocation_to_reverse || 0),
    warnings: preview?.warnings || [],
});

export const getReceiptItemValidationMessage = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) {
        return 'Phiếu thu thanh toán phải có ít nhất một dịch vụ hoặc sản phẩm hợp lệ.';
    }

    const invalidIndex = items.findIndex(item => {
        if (!item || typeof item !== 'object') return true;

        const type = String(item.type || '').trim();
        const customerServiceId = Number(item.customer_service_id || 0);
        if (type === 'Dịch vụ') return !Number.isInteger(customerServiceId) || customerServiceId <= 0;

        if (type !== 'Sản phẩm') return true;
        const productSaleId = Number(item.product_sale_id || 0);
        if (Number.isInteger(productSaleId) && productSaleId > 0) return false;

        const productId = Number(item.origin_id || 0);
        const quantity = Number(item.quantity);
        const price = Number(item.price);
        return !Number.isInteger(productId) || productId <= 0
            || !String(item.name || '').trim()
            || !Number.isInteger(quantity) || quantity <= 0
            || !Number.isFinite(price) || price < 0;
    });

    return invalidIndex >= 0
        ? `Dòng nội dung số ${invalidIndex + 1} không hợp lệ. Vui lòng chọn lại dịch vụ hoặc sản phẩm.`
        : null;
};

export const buildReceiptMutationControlFields = (preview, mutationKey) => {
    if (!preview?.financial_changed) return {};
    return {
        mutation_key: mutationKey,
        ...(preview.requires_confirmation ? { confirmation_token: preview.confirmation_token } : {}),
    };
};

export const getAvailableCustomerServices = (services = [], items = []) => {
    const existingIds = new Set((items || [])
        .filter(item => item.type === 'Dịch vụ' && item.customer_service_id)
        .map(item => Number(item.customer_service_id)));
    const seenIds = new Set();
    return (services || []).filter(service => {
        const id = Number(service?.id || 0);
        const isAvailable = id > 0
            && Number(service?.outstanding_amount || 0) > 0
            && !existingIds.has(id)
            && !seenIds.has(id);
        if (isAvailable) seenIds.add(id);
        return isAvailable;
    });
};

export const appendCustomerServices = (items = [], services = [], selectedIds = []) => {
    const selected = new Set((selectedIds || []).map(Number));
    const additions = getAvailableCustomerServices(services, items)
        .filter(service => selected.has(Number(service.id)))
        .map(service => ({
            id: service.id,
            key: `Dịch vụ-${service.id}`,
            origin_id: service.service_id,
            name: service.service?.name || service.service_name || 'Dịch vụ',
            type: 'Dịch vụ',
            price: Number(service.sale_price || 0),
            quantity: Number(service.quantity || 1),
            amount: Number(service.outstanding_amount || 0),
            outstanding_amount: Number(service.outstanding_amount || 0),
            allocated_amount: Number(service.allocated_amount || 0),
            line_total: Number(service.sale_price || 0) * Number(service.quantity || 1),
            customer_service_id: service.id,
        }));
    return [...(items || []), ...additions];
};
